import { Card, CardBody, Col, Row } from "reactstrap";
import { Btn, H5, Image, P } from "../../../AbstractElements";
import { Href, PlaceholderCardsTitle } from "../../../Constants/Constants";
import { PlaceholderCardsSubTitle } from "../../../Data/UiKits/Placeholders";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const PlaceholderCards = () => {
  return (
    <Col xxl="6" className="box-col-12">
      <Card>
        <CommonCardHeader title={PlaceholderCardsTitle} span={PlaceholderCardsSubTitle} />
        <CardBody className="loading-card-wrapper">
          <Row className="gy-3">
            <Col sm="6">
              <Card className="mb-0 overflow-hidden">
                <Image className="card-img-top img-fluid" src={dynamicImage("masonry/5.jpg")} alt="" />
                <CardBody>
                  <H5 className="card-title">Card title</H5>
                  <P className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</P>
                  <Btn color="primary" tag={"a"} href={Href}>Go somewhere</Btn>
                </CardBody>
              </Card>
            </Col>
            <Col sm="6">
              <Card className="mb-0 overflow-hidden" aria-hidden="true">
                <Image className="card-img-top img-fluid" src={dynamicImage("masonry/13.jpg")} alt="" />
                <CardBody>
                  <H5 className="card-title placeholder-glow">
                    <Col xs="4" className="placeholder placeholder-light" />
                  </H5>
                  <div className="card-text placeholder-glow mb-3">
                    <Col xs="7" className="placeholder placeholder-light" />
                    <Col xs="4" className="placeholder placeholder-light ms-1" />
                    <Col xs="4" className="placeholder placeholder-light" />
                    <Col xs="6" className="placeholder placeholder-light ms-1" />
                    <Col xs="3" className="placeholder placeholder-light" />
                  </div>
                  <Col xs="6">
                    <Btn color="primary" tag={"a"} href={Href} className="disabled placeholder w-100" />
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PlaceholderCards;
